import { Fragment, PropsWithChildren, useCallback, useId } from 'react';
import { ChevronsDownUp, ChevronsUpDown } from 'lucide-react';

import { Button } from '@components/primitives';

import css from './styles.module.css';

export interface PreviewModeProps extends PropsWithChildren {
  enabled: boolean;
  lines: number;
  lineHeight: number;
  active: boolean;
  onActiveChange(active: boolean): void;
}

export function PreviewMode({
  children,
  enabled,
  lines,
  lineHeight,
  active,
  onActiveChange,
}: PreviewModeProps) {
  const id = useId();

  const handleActiveChange = useCallback(() => {
    onActiveChange(!active);
  }, [active, onActiveChange]);

  return (
    <div
      className={css.previewable}
      data-can-preview={enabled}
      data-active={active}
      style={{
        '--line-height': `${lineHeight}px`,
        '--preview-lines': lines,
      }}
    >
      {enabled && (
        <Fragment>
          <div className={css.previewGradient} />

          <Button
            type="button"
            size="xs"
            className={css.previewButton}
            aria-expanded={!active}
            aria-controls={id}
            onClick={handleActiveChange}
          >
            {active ? (
              <ChevronsUpDown
                className={css.previewButtonIcon}
                aria-hidden="true"
              />
            ) : (
              <ChevronsDownUp
                className={css.previewButtonIcon}
                aria-hidden="true"
              />
            )}
            {active ? 'Expand' : 'Collapse'}
          </Button>
        </Fragment>
      )}

      <div id={id} className={css.previewContent}>
        {children}
      </div>
    </div>
  );
}
